import { render, staticRenderFns } from "./KisCommitteeEditDialog.vue?vue&type=template&id=704bc501"
import script from "./KisCommitteeEditDialog.js?vue&type=script&lang=js&external"
export * from "./KisCommitteeEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports